import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function ViewConvenioFinisa() {
  const [data, setData] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();

  const formatBRL = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    const num = Number(value);
    if (isNaN(num)) return "-";
    return num.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const carregarDados = () => {
    axios
      .get("/api/conveniosfinisa")
      .then((res) => setData(res.data))
      .catch((err) => {
        console.error("Erro no axios:", err);
        alert("Erro ao carregar dados do servidor");
      });
  };

  useEffect(() => {
    const userRole = localStorage.getItem("UserRole");
    setIsAdmin(userRole === "admin");
    carregarDados();
  }, []);

  const handleDelete = (id) => {
    if (window.confirm("Tem certeza que deseja deletar este convênio?")) {
      axios
        .delete(`/api/conveniosfinisa/${id}`)
        .then((res) => {
          if (res.data.message === "Convenio deletado com sucesso!") {
            alert("Convênio deletado!");
            carregarDados();
          } else {
            alert("Erro ao deletar o convênio");
          }
        })
        .catch((err) => {
          console.error(err);
          alert("Erro no servidor");
        });
    }
  };

  return (
    <div className="fs-11 px-18 py-8" style={{ overflow: "visible" }}>
      <div className="d-flex justify-content-center mb-3">
        <h3>Convênios FINISA</h3>
      </div>

      <div className="mb-3 d-flex align-items-center gap-2 flex-wrap">
        {isAdmin && (
          <Link to="/addconveniosfinisa" className="btn btn-primary">
            + Novo Convênio
          </Link>
        )}
        <Link to="/conveniosestadual" className="btn btn-secondary">Convênios ESTADUAL</Link>
        <Link to="/conveniosfederal" className="btn btn-secondary">Convênios FEDERAL</Link>
        <Link to="/conveniosdade" className="btn btn-secondary">Convênios DADE</Link>
        <Link to="/conveniossempapel" className="btn btn-secondary">Convênios Sem Papel</Link>

        <input
          type="text"
          placeholder="Buscar por Objeto, Empresa, Contrato..."
          className="form-control"
          style={{ maxWidth: "300px" }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div style={{ overflowX: "auto" }}>
        <table className="table table-responsive table-bordered table-hover">
          <thead className="table-success">
            <tr>
              <th>ID</th>
              <th>Objeto</th>
              <th>Objeto Completo</th>
              <th>CP/DL/TP</th>
              <th>Contrato</th>
              <th>Ano</th>
              <th>Valor Total (R$)</th>
              <th>Empresa</th>
              <th>Status</th>
              {isAdmin && <th>Ações</th>}
            </tr>
          </thead>
          <tbody>
            {data
              .filter((item) => {
                const search = searchTerm.toLowerCase();
                return (
                  item.objeto?.toLowerCase().includes(search) ||
                  item.objeto_completo?.toLowerCase().includes(search) ||
                  item.contrato?.toLowerCase().includes(search) ||
                  item.ano?.toString().includes(search) ||
                  item.empresa?.toLowerCase().includes(search) ||
                  item.status?.toLowerCase().includes(search)
                );
              })
              .map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.objeto}</td>
                  <td>{item.objeto_completo}</td>
                  <td>{item.cp_dl_tp}</td>
                  <td>{item.contrato}</td>
                  <td>{item.ano}</td>
                  <td>{formatBRL(item.valor_total)}</td>
                  <td>{item.empresa}</td>
                  <td>{item.status}</td>
                  {isAdmin && (
                    <td>
                      <button
                        className="btn btn-light btn-sm me-2"
                        onClick={() => navigate(`/editconveniofinisa/${item.id}`)}
                      >
                        Editar
                      </button>
                      <button
                        className="btn btn-info btn-sm"
                        onClick={() => handleDelete(item.id)}
                      >
                        Deletar
                      </button>
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ViewConvenioFinisa;
